import type { ZeroResultSearchFilters } from "@/types";

export const ZERO_RESULT_SEARCH_KEY = "ZERO_RESULT_SEARCH";

export const ZERO_RESULT_SEARCH_CACHE_KEYS = {
  LIST: (filters: ZeroResultSearchFilters) =>
    [ZERO_RESULT_SEARCH_KEY, "LIST", filters] as const,
  EVENTS: (queryId: string, page: number, limit: number) =>
    [ZERO_RESULT_SEARCH_KEY, "EVENTS", queryId, page, limit] as const,
};
